import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "text-wrapper" }
const _hoisted_3 = {
  id: "error-body",
  class: "body"
}
const _hoisted_4 = { class: "button-wrapper" }

import { ref, computed } from "vue";
import { IonModal, IonTitle } from "@ionic/vue";
import AppButton from "../AppButton/AppButton.vue";
import { setChatIframeVisibility } from "@/helpers";
import { useI18n } from "vue-i18n";

interface Props {
  title?: string;
  body?: string;
  hasErrored?: boolean;
  imageKey?: imageKey;
  primaryButton?: { label: string; icon?: string };
  secondaryButton?: { label: string; icon?: string };
}

type imageKey = "confusedCharacter";

export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  props: {
    title: { default: () => useI18n().t("error.title") },
    body: { default: () => useI18n().t("error.body") },
    hasErrored: { type: Boolean, default: false },
    imageKey: { default: "confusedCharacter" },
    primaryButton: { default: () => ({
    label: useI18n().t("navigation.reloadPage"),
  }) },
    secondaryButton: { default: () => ({
    label: useI18n().t("navigation.back"),
  }) }
  },
  emits: [
  "onDismiss",
  "onPrimaryButtonClick",
  "onSecondaryButtonClick",
],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v58bbc33c": (imageUrl.value)
}))

const props = __props;
const modal = ref(null);
const emit = __emit;

const dismissHandler = () => {
  setChatIframeVisibility("block");
  emit("onDismiss");
};

const confusedCharacterImage = require("@/assets/em-platformGuide-confused.svg");
const imageMap: Map<imageKey, any> = new Map([
  ["confusedCharacter", confusedCharacterImage],
]);

const imageUrl = computed(() => {
  return "url(" + imageMap.get(props.imageKey) + ")";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    ref_key: "modal",
    ref: modal,
    "is-open": __props.hasErrored,
    "backdrop-dismiss": false,
    onDidPresent: _cache[2] || (_cache[2] = ($event: any) => (_unref(setChatIframeVisibility)('none'))),
    onDidDismiss: dismissHandler,
    "aria-labelledby": "error-title",
    "aria-describedby": "error-body",
    "aria-busy": "false",
    role: "dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "image-wrapper" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonTitle), {
            id: "error-title",
            class: "title",
            size: "small",
            role: "heading",
            "aria-level": "2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.body), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AppButton, {
            "data-test": "primary-button",
            type: "primary",
            size: "default",
            width: "100%",
            label: __props.primaryButton.label,
            ariaLabel: __props.primaryButton.label,
            icon: __props.primaryButton.icon,
            iconPosition: "end",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onPrimaryButtonClick')))
          }, null, 8, ["label", "ariaLabel", "icon"]),
          (__props.secondaryButton)
            ? (_openBlock(), _createBlock(AppButton, {
                key: 0,
                "data-test": "secondary-button",
                size: "default",
                width: "100%",
                type: "secondary",
                label: __props.secondaryButton.label,
                ariaLabel: __props.secondaryButton.label,
                icon: __props.secondaryButton.icon,
                iconPosition: "end",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onSecondaryButtonClick')))
              }, null, 8, ["label", "ariaLabel", "icon"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})